export const chartColors = [
  '#5cb3ff', '#F0BB58', '#43C4E2', '#f57f31', '#58D9AC', '#3A90E8','#576BF2','#6E69FE','#8366FC','#AD71E9',
  '#5cb3ff', '#F0BB58', '#43C4E2', '#f57f31', '#58D9AC', '#3A90E8','#576BF2','#6E69FE','#8366FC','#AD71E9',
  '#5cb3ff', '#F0BB58', '#43C4E2', '#f57f31', '#58D9AC', '#3A90E8','#576BF2','#6E69FE','#8366FC','#AD71E9'
];

export const xLabelColor = {'white': '#333333', 'dark': '#ebedee'};

function cutZero(oldnumber){
  let data = oldnumber;
  //判断变量类型  number类型不做处理，直接输出；string类型进行处理；
  if(typeof(data) != 'number'){
    data = data.trim(); //字符串首尾做去除空格处理
    let hasCode = data.indexOf(".")
    //小数
    if(hasCode > -1){
      let ary = data.split(".")
      let integer = ary[0]
      let decimal = ary[1]
      //整数部分
      for(let i=0; i<integer.length; i++){
        if(integer.length != 1 && integer.indexOf('0') > -1 && integer.indexOf('0') == 0) integer = integer.replace('0','')
      }
      //小数部分
      for(let j=0; j<=decimal.length; j++){
        if(decimal.length != 0 && decimal.lastIndexOf('0') > -1 && decimal.lastIndexOf('0') == decimal.length-1) decimal = decimal.substring(0,decimal.length-1)
      }
      if(decimal.length == 0){
        data = integer
      }else{
        data = integer.concat('.',decimal)
      }
    }
    //整数
    else{
      for(let i=0; i<data.length; i++){
        if(data.length != 1 && data.indexOf('0') > -1 && data.indexOf('0') == 0) data = data.replace('0','')
      }
    }

  }
  return data
}

export function numberConversion(value) {
  let isCN = localStorage.getItem('locale') === 'cn';

  if (isCN){
    return numberConversionChinese(value);
  } else {
    return numberConversionEnglish(value);
  }
}

function numberConversionChinese(value) {
  let kw = '千万';
  let w = '万';
  let ky = '千亿';
  let y = '亿';
  let wy = '万亿';
  let kwy = '千万亿';

  const newValue = ['', '', ''];
  let fr = 1000;
  let num = 3;
  let txt = '';
  let fm = 1;
  while (value / fr >= 1) {
    fr *= 10;
    num += 1;
  }
  if (num <= 4) { // 千
    newValue[0] = parseInt(value) + '';
    newValue[1] = '';
  } else if (num <= 8) { // 万
    txt = parseInt(num - 4) / 3 > 1 ? kw : w;
    fm = txt === '万' ? 10000 : 10000000;
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + '';
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(1) + '';
    }
    newValue[1] = txt;
  } else if (num <= 16) { // 亿
    txt = (num - 8) / 3 > 1 ? ky : y;
    txt = (num - 8) / 4 > 1 ? wy : txt;
    txt = (num - 8) / 7 > 1 ? kwy : txt;

    fm = 1;
    if (txt === y) {
      fm = 100000000;
    } else if (txt === ky) {
      fm = 100000000000;
    } else if (txt === wy) {
      fm = 1000000000000;
    } else if (txt === kwy) {
      fm = 1000000000000000;
    }
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + '';
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(1) + '';
    }
    newValue[1] = txt;
  }
  if (value < 1000) {
    newValue[0] = value + '';
    newValue[1] = '';
  }

  return newValue.join('');
}

function numberConversionEnglish(value) {
  let k = 'THS';
  let bw = 'M';
  let sy = 'B';
  let wy = 'TN';

  const newValue = ['', '', ''];
  let fr = 1000;
  let num = 3;
  let txt = '';
  let fm = 1;
  while (value / fr >= 1) {
    fr *= 10;
    num += 1;
  }

  if (value < 1000) {
    newValue[0] = value + '';
    newValue[1] = '';
  }else{
    if (num <= 5) { // 千
      newValue[0] = cutZero((value  / 1000).toFixed(2));
      newValue[1] = k;
    } else if (num <= 9) { // 百万
      newValue[0] = cutZero((value  / 1000000).toFixed(2));
      newValue[1] = bw;
    } else if (num <= 12) { // 十亿
      newValue[0] = cutZero((value  / 1000000000).toFixed(2));
      newValue[1] = sy;
    } else if (num > 12) { // 万亿
      newValue[0] = cutZero((value  / 1000000000000).toFixed(2));
      newValue[1] = wy;
    }
  }

  return newValue.join('');
}

export const chartBarOption = {
  title: {

  },
  color: chartColors,
  tooltip: {
    trigger: 'item',
    confine: true
  },
  legend: {
    top: '5',
    itemWidth: 16,
    itemHeight: 10,
    textStyle: {
      color: xLabelColor[sessionStorage.getItem('theme')],
    }
  },
  xAxis: {
    type: 'category',
    axisLine: {
      show: false
    },
    axisLabel: {
      fontSize: 12,
      color: xLabelColor[sessionStorage.getItem('theme')]
    },
    axisTick: {
      show: false,
    },
  },
  grid: {
    bottom: '3%',
    left: 20,
    right: 20,
    containLabel: true
  },
  yAxis: {
    type: 'value',
    axisTick: {
      show: false,
    },
    axisLabel: {
      fontSize: 12,
      color: xLabelColor[sessionStorage.getItem('theme')],
      formatter: function(value) {
        return numberConversion(value);
      },
    },
    splitLine: {
      lineStyle: {
        color: '#aaaaaa',
        type: 'dashed',
      }
    }
  },
  series: []
};

export const chartHorizontalBarOption = {
  color: chartColors,
  tooltip: {
    trigger: 'axis',
    confine: true
  },
  grid: {
    bottom: '3%',
    left: 20,
    right: 20,
    containLabel: true
  },
  xAxis: {
    type: 'value',
    axisLine: {
      show: true,
      lineStyle: {
        color: '#999999',
      }
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      fontSize: 12,
      color: xLabelColor[sessionStorage.getItem('theme')]
    },
    splitLine: {
      lineStyle: {
        color: '#aaaaaa',
        type: 'dashed',
      }
    }
  },
  yAxis: {
    type: 'category',
    axisLine: {
      show: false
    },
    axisLabel: {
      fontSize: 12,
      color: xLabelColor[sessionStorage.getItem('theme')],
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      type: 'bar',
    }
  ]
};

export const chartLineOption = {
  color: chartColors,
  tooltip: {
    trigger: 'axis',
    confine: true
  },
  legend: {
    top: '5',
    type: 'scroll',
    orient: 'horizontal',
    pageIconInactiveColor: '#999999',
    pageIconColor: xLabelColor[sessionStorage.getItem('theme')],
    pageTextStyle: {
      color:xLabelColor[sessionStorage.getItem('theme')],
    },
    itemWidth: 16,
    itemHeight: 10,
    textStyle: {
      color: xLabelColor[sessionStorage.getItem('theme')],
    }
  },
  grid: {
    bottom: '3%',
    left: 20,
    right: 20,
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    axisLine: {
      show: false
    },
    axisLabel: {
      fontSize: 12,
      color: xLabelColor[sessionStorage.getItem('theme')]
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    type: 'value',
    axisTick: {
      show: false,
    },
    axisLabel: {
      fontSize: 12,
      color: xLabelColor[sessionStorage.getItem('theme')],
      formatter: function(value) {
        return numberConversion(value);
      },
    },
    splitLine: {
      lineStyle: {
        color: '#aaaaaa',
        type: 'dashed',
      }
    }
  },
  series: []
};

export const pieChartOption = {
    color: chartColors,
    tooltip: {
      trigger: 'item',
      confine: true
    },
    legend: {
      type: 'scroll',
      orient: 'horizontal',
      pageIconInactiveColor: '#999999',
      pageIconColor: xLabelColor[sessionStorage.getItem('theme')],
      pageTextStyle: {
        color:xLabelColor[sessionStorage.getItem('theme')],
      },
      itemWidth: 10,
      itemHeight: 10,
      textStyle: {
        color: xLabelColor[sessionStorage.getItem('theme')],
      },
      formatter: function (name) {
        if (!name) return ''
        // 超出几个字符隐藏，鼠标悬浮时显示
        // if (name.length > 8) {
        //   name = name.slice(0, 8) + '...'
        // }
        return name
      }
    },
    grid: {
      bottom: '3%',
      left: 20,
      right: 20,
      containLabel: true
    },
    series: [
      {
        type: 'pie',
        top: '10%',
        radius: '70%',
        label: {
          color: xLabelColor[sessionStorage.getItem('theme')],
        },
        normal: {
          formatter: '{@percentage}',
          position: 'inside',
          fontSize: 10,
          color: '#fff',
          align: 'center',
          verticalAlign: 'middle'
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
};
